import React from 'react';

export default function EmptySiteState({
  projectName,
  catalogueError,
  canManageFiles,
  onOpenFileManagement,
  onOpenLayers,
  onRefreshCatalogue,
}) {
  return (
    <div className="absolute inset-0 z-[50] flex items-center justify-center p-6 pointer-events-none">
      <div className="pointer-events-auto w-full max-w-md rounded-md border border-yellow-600/35 bg-zinc-950/95 shadow-[0_20px_50px_rgba(0,0,0,0.55)] backdrop-blur-md p-5">
        <p className="text-[9px] uppercase tracking-[0.16em] text-yellow-500/80">
          {typeof navigator !== 'undefined' && navigator.onLine === false ? 'Offline' : 'No models yet'}
        </p>
        <h2 className="text-sm font-semibold text-yellow-400 mt-1 tracking-wide">
          {typeof navigator !== 'undefined' && navigator.onLine === false
            ? 'No cached catalogue on this device'
            : `${projectName || 'This site'} needs a catalogue`}
        </h2>
        <p className="text-[11px] text-zinc-400 mt-2 leading-relaxed">
          {typeof navigator !== 'undefined' && navigator.onLine === false ? (
            <>
              Open the app once while online so the layer list can be stored. Models you already loaded
              will appear after that, even with no network.
            </>
          ) : (
            <>
              Upload <span className="text-zinc-200">.glb</span> or zipped block models to the server{' '}
              <span className="text-zinc-200">models/</span> folder, or use File Management if you have access.
              Set map origin and defaults in <span className="text-zinc-200">site.json</span> on the server.
            </>
          )}
        </p>
        {catalogueError ? (
          <p className="mt-3 text-[10px] text-red-400/90 leading-relaxed border border-red-900/50 rounded-sm px-2 py-1.5 bg-red-950/30">
            {catalogueError}
          </p>
        ) : null}
        <ol className="mt-3 space-y-1.5 text-[11px] text-zinc-500 list-decimal list-inside">
          <li>Copy GLBs or block-model zips into <code className="text-zinc-300">models/Group/Category/</code></li>
          <li>Edit <code className="text-zinc-300">react-build/site.json</code> — origin, default layers, camera</li>
          <li>Refresh the catalogue (Layers panel → Refresh)</li>
        </ol>
        <div className="mt-4 flex flex-wrap gap-2">
          {canManageFiles ? (
            <button
              type="button"
              className="m-0 min-h-[44px] h-11 px-3 text-[10px] font-semibold uppercase tracking-wider bg-yellow-500 text-black rounded hover:bg-yellow-400"
              onClick={onOpenFileManagement}
            >
              File Management
            </button>
          ) : null}
          <button
            type="button"
            className="m-0 min-h-[44px] h-11 px-3 text-[10px] uppercase tracking-wider text-yellow-400 border border-yellow-600/40 rounded hover:bg-yellow-500/10"
            onClick={onOpenLayers}
          >
            Open layers
          </button>
          <button
            type="button"
            className="m-0 min-h-[44px] h-11 px-3 text-[10px] uppercase tracking-wider text-zinc-400 border border-zinc-700 rounded hover:border-yellow-500/40 hover:text-yellow-400"
            onClick={onRefreshCatalogue}
          >
            Refresh catalogue
          </button>
        </div>
      </div>
    </div>
  );
}
